import AdproductsConstants from 'app/shared/constants/AdproductsConstants';

const { ProductCodes, ProductTypes, PackageTypes } = AdproductsConstants;

const adproductsUtils = {
    getOneYearMonthRanges: (date = new Date()) => {
        const ranges = [];
        date.setDate(1);
        const endDate = new Date(date.valueOf());
        const startDate = new Date(date.valueOf());
        startDate.setMonth(startDate.getMonth() - 11);

        while (startDate <= endDate) {
            ranges.push([startDate.getFullYear(), startDate.getMonth()]);
            startDate.setMonth(startDate.getMonth() + 1);
        }

        return ranges;
    },
    createDateFromYearMonth(year, month) {
        const date = new Date();
        date.setFullYear(year);
        date.setMonth(month, 1);
        return date;
    },
    hasPackage(productTypes = []) {
        return productTypes.some(productType => PackageTypes.has(productType));
    },
    hasRocketship(productTypes = []) {
        return productTypes.some(productType => productType === ProductCodes.SINGLE_FAMILY_DAILY_LISTINGS);
    },
    hasReit(productTypes = []) {
        return productTypes.some(productType => productType === ProductCodes.SINGLE_FAMILY);
    },
    mapProductTypes(productTypes = []) {
        const hasPackage = this.hasPackage(productTypes);
        let mappingTypes = productTypes;
        if (hasPackage) {
            mappingTypes = productTypes.filter(productType => PackageTypes.has(productType));
        }
        const set = new Set(mappingTypes.map(productType => ProductTypes[productType]));
        return [...set];
    },
    containsOnlyPackageProducts(invoices = []) {
        if (!invoices || !invoices.length) {
            return false;
        }
        return invoices.flatMap((invoice) => {
            if (invoice.adproductCodes.some(code => PackageTypes.has(code))) {
                return invoice.adproductCodes.filter(code => PackageTypes.has(code));
            }
            return invoice.adproductCodes;
        }).every(code => PackageTypes.has(code));
    },
};

export default adproductsUtils;
